/* eslint-disable react/no-children-prop */
import { IconButton, useColorModeValue } from '@chakra-ui/react';
import { Eye } from 'phosphor-react';
import React from 'react';

export const ViewButton = ({ onClick }: any) => {
  return (
    <IconButton
      onClick={onClick}
      color={useColorModeValue('theme.light.tertiary', 'theme.dark.tertiary')}
      icon={<Eye size={25} />}
      size="sm"
      mr={2}
      variant="ghost"
      _hover={{ opacity: 0.5 }}
      aria-label=""
    />
  );
};
